const EventType = {
    GO_BACK: 'GO_BACK',
};

export default EventType;
